export const endereco_empty = () => ({
  cep: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade_id: null,
  pais_id: null,
  internacional: false,
  internacional_descricao: "",
});
